export default {
	loggingName: "Bothive widget",
	errors: {
		couldNotAttach:
			`Could not initialize the widget. No <body /> or <html /> tag present in the html.
			Please supply us an elementId or make sure that your document has a <body /> or <html /> tag.`,
		noApiKey: "Please add an api key in the settings object.",
		apiKeyInvalid: "Please make sure you supply a valid api key. You can find your api key in the dashboard.",
		corsError: "Please make sure this domain is added to the trusted domains in the dasboard.",
		noActiveSubscription: `Your team does not have an active subscription.
		 You either cancelled it or your payment is still processing.
		 It can take up to 15 minutes for new subscriptions to activate.
		 If it takes longer please contact support.`
	},
	warnings: {
		alreadyLoaded: "Init call ignored. Bothive has already been initialised.",
	}
};
